import React, { FC } from 'react';
import { TableBody, TableHead, TableRow, TableCell, TableContainer } from '@material-ui/core';
import BodyRow from './components/BodyRow';
import { TableCustom } from 'components/Table';

interface Props {
  isLoadingData: boolean;
  stockItem: StockItemModel[];
}

const ListProduct: FC<Props> = props => {
  const { isLoadingData, stockItem } = props;
  return (
    <TableContainer>
      <TableCustom size='small'>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Nama Produk</TableCell>
            <TableCell>Kategori</TableCell>
            <TableCell>Harga Beli</TableCell>
            <TableCell>Stok Ditambahkan</TableCell>
            <TableCell>Total Harga</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stockItem.length > 0 &&
            stockItem.map((value, index) => <BodyRow isLoading={isLoadingData} stockItem={value} />)}
        </TableBody>
      </TableCustom>
    </TableContainer>
  );
};

export default ListProduct;
